import React from "react";
import "./navbar.css";
import Container from "react-bootstrap/Container";
import Navbarrr from "./navbarrr";
import Carousel1 from "./carousel";
import { Col, Row } from "antd";
import { Card } from "antd";
import Footer from "./footer";

function Navbar1() {
  return (
    <div>
      <Navbarrr />
      <Carousel1 />
      <div>
        <Row className="rowwww">
          <Col span={12} className="cardss">
            <div className="cardss">
              <Card
                hoverable
                style={{
                  width: 200,
                }}
                cover={<img alt="example" src="images/montessori.jpg" />}
              >
                <h3>Montessori</h3>
              </Card>

              <Card
                hoverable
                style={{
                  width: 200,
                }}
                cover={
                  <img
                    height={300}
                    width={300}
                    alt="example"
                    src="images/lower.jpg"
                  />
                }
              >
                {" "}
                <h3>Lower School</h3>
              </Card>
            </div>

            <div className="cardss">
              {" "}
              <Card
                hoverable
                style={{
                  width: 200,
                }}
                cover={
                  <img
                    height={300}
                    width={300}
                    alt="example"
                    src="images/middle.jpg"
                  />
                }
              >
                {" "}
                <h3>Middle School</h3>
              </Card>
              <Card
                hoverable
                style={{
                  width: 200,
                }}
                cover={<img alt="example" src="images/high.jpg" />}
              >
                {" "}
                <h3>High School </h3>
              </Card>
            </div>
          </Col>
          <Col span={12}>
            <p className="textttt">
              FOR MORE THAN 8 YEARS,
              <span className="spannntxttt">
                <br />
                New Lahore Science Academy has been a leader in independent
                educational institute throughout Lahore,pakistan. Located just
                five minutes from downtown, we are a co-ed, college-preparatory
                Academy with a Montessori through grade 12. <br />
                Our mission is to develop leaders of character across five
                pillars: <br />
                1: Academic,
                <br /> 2: Athletic, <br />
                3: Social,
                <br /> 4: Spiritual and <br />
                5: Artistic.
              </span>
            </p>
          </Col>
        </Row>
      </div>
      <div className="anthertxtt">
        <div className="principllll">
          {" "}
          <p className="pprrrr">
            Experience The Nlsa <br />
          </p>
        </div>{" "}
        <h5 style={{ color: "black", marginTop: "2rem" }}>
          As an independent institute, we continue our founding traditions as a
          Notre Dame <br />
          community. The heart of our mission is to educate leaders of character
          who will value and
          <br /> improve the world they inherit. Here in a warm, inclusive
          culture, every child is known, their
          <br /> God-given talents are valued and relationships flourish.
        </h5>
      </div>
      <div className="rowwww">
        <div className="cardmidd">
          <Card bordered={false} style={{ width: 300 }}>
            <p className="ldrrrr">Academic Excellence</p>
            <p className="ldrrrrr">
              HIGH EXPECTATIONS DELIVER OUTSTANDING RESULTS
            </p>
          </Card>

          <Card bordered={false} style={{ width: 300 }}>
            <p className="ldrrrr">Spiritual Growth</p>
            <p className="ldrrrrr">
              INCLUSIVE COMMUNITY FOSTERS VALUES AND GUIDES FAITH FORMATION
            </p>
          </Card>
        </div>
        <div className="cardmidd1">
          <Card bordered={false} style={{ width: 300 }}>
            <p className="ldrrrr">Leaders of Character</p>
            <p className="ldrrrrr">
              MISSION CHALLENGES ALL TO BE PEACEMAKERS, CHANGEMAKERS.
            </p>
          </Card>
        </div>
      </div>
      <div className="rowwww">
        <div className="principllll">
          {" "}
          <p className="pprrrr">
            Message By The Principal <br />
          </p>
        </div>
        <div className="cardmidd1">
          <Card
            hoverable
            style={{
              width: 180,
              marginTop: "3rem",
            }}
            cover={<img alt="example" src="images/shahroz.jpg" />}
          ></Card>
        </div>
        <Container className="txtprincipallll">
          “ Principal's Message Getting children into school is one thing,
          educating them is quite another. The former may be easier but the
          latter task is quite daunting nowadays. These are sensitive times and
          maintaining a balance between quality education and character building
          aligned with our religion is no easy feat. We at The Intellect strive
          to our best to do exactly that. At the Intellect, we believe that the
          role of a school is not only to enable academic excellence, but also
          to motivate and empower its students to be lifelong learners, critical
          thinkers, and productive members of an ever-changing global society.
          As Muslims, this also includes the importance of trust, respect,
          innovation, and a sense of belonging to the Muslim Ummah.
          <br /> Our curriculum emphasises active learning, understanding,
          critical thinking, and problem-solving capabilities. We endeavour to
          inculcate within each student the practice of taking ownership of
          one’s own learning. It is our responsibility as educators to nurture
          and develop every pupil to prepare them for life. Students are
          continually encouraged to participate in diverse activities, enabling
          them to develop an awareness about global issues, and an active
          respect for the environment. <br />
          At The Intellect better prospects await for your child. We have an
          outstanding standard of teacher recruitment along with different
          professional development courses for teachers, as we persevere on this
          path. It is quality education with religious upbringing that will
          speak for a mammoth difference between your child and the rest.
          JazakAllah Khairan <br />
          Sir Shahroz Khan
          <br />
          Principal
          <br />
          New Lahore Science Academy.
        </Container>
      </div>
      <div>
        <h2 className="hhhhh333"> MEET THE TEACHERS</h2>
        <div className="tchers">
          <Card
            hoverable
            style={{
              width: 300,
            }}
            cover={<img alt="example" src="images/teacher1.jpeg" />}
          >
            <p className="tchrtxt">
              Sir Hafiz M.Hammad Akhtar
              <br />
              M.S.C botany <br /> Punjab university Lahore
            </p>
          </Card>

          <Card
            hoverable
            style={{
              width: 350,
            }}
            cover={<img alt="example" src="images/teacher2.jpeg" />}
          >
            <p className="tchrtxt">
              Sir Hamza Khan
              <br />
              M.S.C Cont <br />
              Mathematics
            </p>
          </Card>

          <Card
            hoverable
            style={{
              width: 300,
            }}
            cover={<img alt="example" src="images/teacher3.jpeg" />}
          >
            <p className="tchrtxt">
              Miss Wajiha Naeem
              <br />
              M.A in English Literature <br />
              Punjab University
            </p>
          </Card>
        </div>
        <div className="tchers">
          <Card
            hoverable
            style={{
              width: 300,
            }}
            cover={<img alt="example" src="images/teacher4.jpg" />}
          >
            <p className="tchrtxt">
              Sir Ikram Akram
              <br />
              BSCS Cont <br />
              NCBA&E
            </p>
          </Card>
          <Card
            hoverable
            style={{
              width: 300,
            }}
            cover={<img alt="example" src="images/teacher5.jpeg" />}
          >
            <p className="tchrtxt">
              Miss saba
              <br />
              Urdu lecturer
              <br />
              M.A continue
            </p>
          </Card>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Navbar1;
